
export const articles = [
  {
    id: '1',
    title: 'Why Your Next CMO Should Be Fractional: A Strategic Imperative',
    excerpt: 'Traditional marketing leadership models are broken. Companies waste millions on full-time executives who lack specialized expertise. Fractional CMOs deliver world-class marketing strategy with precision execution—no corporate bloat, just results.',
    category: 'Marketing',
    author: 'Tom Shock',
    publishDate: '2024-03-15',
    coverImage: 'https://public.readdy.ai/ai/img_res/edited_abedec462a76f304fe63ff053e3ce321_1d266a67.jpg',
    readTime: '7 min read'
  },
  {
    id: '2',
    title: 'Revenue Architecture: How Embedded Sales Leaders Build Unstoppable Growth Engines',
    excerpt: 'Most sales teams underperform because they lack systematic approaches to revenue generation. Our embedded sales leaders don\'t just coach—they architect scalable systems that turn average performers into revenue champions.',
    category: 'Sales',
    author: 'Tom Shock',
    publishDate: '2024-03-10',
    coverImage: 'https://public.readdy.ai/ai/img_res/3fc29d6b307e70c2e6f218e84463ecf0.jpg',
    readTime: '9 min read'
  },
  {
    id: '3',
    title: 'The Death of Traditional Consulting: Enter the Age of Embedded Expertise',
    excerpt: 'Consulting firms charge premium rates to deliver PowerPoints that gather dust. We embed senior professionals directly into your operations. They don\'t advise—they execute. The difference? Your team actually achieves the transformation.',
    category: 'Strategy',
    author: 'Tom Shock',
    publishDate: '2024-03-05',
    coverImage: 'https://readdy.ai/api/search-image?query=Business%20transformation%20workshop%20with%20embedded%20expert%20working%20directly%20alongside%20internal%20team%20members%20in%20modern%20office%20environment%20showing%20hands-on%20collaboration%20and%20strategic%20planning&width=800&height=500&seq=article3&orientation=landscape',
    readTime: '6 min read'
  },
  {
    id: '4',
    title: 'Brand Surgery: When Your Identity Needs Emergency Intervention',
    excerpt: 'Stagnant brands die slow deaths in today\'s marketplace. Sometimes you need surgical precision to revive brand relevance. Our fractional brand officers diagnose the real issues and perform the necessary transformations to restore competitive edge.',
    category: 'Branding',
    author: 'Tom Shock',
    publishDate: '2024-02-28',
    coverImage: 'https://readdy.ai/api/search-image?query=Creative%20brand%20renovation%20process%20with%20brand%20identity%20elements%20and%20strategic%20design%20materials%20spread%20across%20modern%20design%20studio%20workspace%20showing%20brand%20transformation%20methodology&width=800&height=500&seq=article4&orientation=landscape',
    readTime: '8 min read'
  },
  {
    id: '5',
    title: 'E-commerce Nightmares: What Happens When Technology Outpaces Strategy',
    excerpt: 'Beautiful websites that don\'t convert. Sophisticated platforms that confuse customers. Technology without strategy is expensive decoration. Learn how embedded commerce experts align tech capabilities with business objectives to drive real ROI.',
    category: 'Technology',
    author: 'Tom Shock',
    publishDate: '2024-02-20',
    coverImage: 'https://readdy.ai/api/search-image?query=E-commerce%20technology%20optimization%20showing%20complex%20digital%20platform%20interfaces%20and%20conversion%20analytics%20in%20high-tech%20workspace%20environment%20with%20multiple%20monitors%20and%20sophisticated%20development%20tools&width=800&height=500&seq=article5&orientation=landscape',
    readTime: '11 min read'
  },
  {
    id: '6',
    title: 'Customer Journey Mapping: Beyond Pretty Diagrams to Profit-Driving Experiences',
    excerpt: 'Every touchpoint either builds loyalty or destroys it. Most companies track metrics but miss the emotional architecture of customer relationships. Discover how embedded CX leaders engineer experiences that turn customers into advocates.',
    category: 'Experience',
    author: 'Tom Shock',
    publishDate: '2024-02-15',
    coverImage: 'https://readdy.ai/api/search-image?query=Customer%20experience%20design%20laboratory%20with%20journey%20mapping%20visualization%20tools%20and%20user%20interface%20prototypes%20showing%20sophisticated%20customer%20experience%20architecture%20and%20research%20methodology&width=800&height=500&seq=article6&orientation=landscape',
    readTime: '10 min read'
  }
];
